var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var FocusIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 80,
    glyphHeight: 80
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2809 79.7736C42.8745 79.9233 41.4462 80 40 80C38.5538 80 37.1256 79.9233 35.7191 79.7736V72.107L39.786 67.8261L44.2809 72.107V79.7736ZM79.7736 44.2809C79.9233 42.8745 80 41.4462 80 40C80 38.5538 79.9233 37.1256 79.7736 35.7191H72.107L67.8261 40L72.107 44.2809H79.7736ZM44.2809 0.226393V7.89298L40 12.1739L35.7191 7.89298V0.226393C37.1256 0.0767478 38.5538 0 40 0C41.4462 0 42.8745 0.0767478 44.2809 0.226393ZM0.226393 35.7191C0.0767478 37.1256 0 38.5538 0 40C0 41.4462 0.0767478 42.8745 0.226393 44.2809H7.89298L12.1739 39.786L7.89298 35.7191H0.226393ZM39.9999 20.7357C29.2975 20.7357 20.7357 29.2975 20.7357 39.9999C20.7357 50.7022 29.2975 59.2641 39.9999 59.2641C50.7022 59.2641 59.2641 50.7022 59.2641 39.9999C59.2641 29.2975 50.7022 20.7357 39.9999 20.7357ZM39.9999 50.7022C34.0066 50.7022 29.2975 45.9932 29.2975 39.9999C29.2975 34.0066 34.0066 29.2975 39.9999 29.2975C45.9932 29.2975 50.7022 34.0066 50.7022 39.9999C50.7022 45.9932 45.9932 50.7022 39.9999 50.7022Z",
    fill: "black"
  }));
};
export var FocusIconGlyph = function (props) {
  return React.createElement(FocusIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};